import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { IBasicCenterListResponse } from '@nkr/store/index';
import { IGroup, IRole, ICenter, ICenterBase } from '@nkr/models/index';
import { OrganType } from '@nkr/enums/index';
import { useAppHookContext } from '@nkr/utils/rest-api';
import AdminMenus from './admin-menus';
import CenterMenus from './center-menus';
import LogisticsProviderMenus from './logistics-provider-menu';
import MicrositeCoachMenus from './microsite-coach-menu';
import NkdoMenus from './nkdo-menus';
import OpsMenus from './ops-menus';
import OpoMenus from './opo-menus';

interface IProps extends RouteComponentProps<{}> {
    firstName: string,
    lastName: string,
    username: string,
    currentUrl: string,
    group: IGroup,
    roles: IRole[],
    isMicrositeCoach: boolean,
    centerId: number,
    centerAlias: string,
    center: ICenter,
    showCenterMenu: boolean,
    notifications: number,
    isLoginRequired: boolean,
    courierName: string,
    onShowNotifications: () => void,
    onGetCenterList: (liverOnly: boolean) => Promise<IBasicCenterListResponse>
}

export const NavMenu = (props: IProps) => {
    const { app: { site: { organ, organType } } } = useAppHookContext();
    const [centerList, setCenterList] = useState<ICenterBase[]>([]);

    useEffect(() => {
        const handler = setTimeout(() => {
            props.onGetCenterList(organType == OrganType.Liver).then(response => {
                setCenterList(response.data.results);
            });
        }, 500);

        return () => {
            clearTimeout(handler);
        }
    }, [organType]);

    const isLoginRequired = props.isLoginRequired;
    const isSuperUser = props.group != null ? props.group.isSuper : false;
    const isCenterUser = props.group ? props.group.isCenter : false;
    const isLogisticsPhlebotUser = props.group ? props.group.isPhlebot : false;
    const isLogisticsProviderUser = props.group ? props.group.isLogisticsProvider : false;
    const isNkdoUser = props.group ? props.group.isNkdo : false;
    const isNkrLabUser = props.group ? props.group.isNkrLab : false;
    const isOpoUser = props.group ? props.group.isOpo : false;

    const isMicrositeCoach =
        !isSuperUser
        && !isCenterUser
        && !isLogisticsPhlebotUser
        && !isLogisticsProviderUser
        && !isNkdoUser
        && !isNkrLabUser
        && props.isMicrositeCoach;

    const isOpo = props.location.pathname.indexOf('/opo') >= 0 && props.location.pathname.indexOf('/admin/opo') < 0;

    switch (true) {
        case isSuperUser:
            if (!props.showCenterMenu) {
                if (!isOpo) {
                    return (
                        <AdminMenus
                            firstName={props.firstName}
                            lastName={props.lastName}
                            username={props.username}
                            currentUrl={props.currentUrl}
                            centerAlias={props.centerAlias}
                            centerId={0}
                            organ={organ}
                            organType={organType}
                            centerList={centerList}
                        />
                    );
                } else {
                    return (
                        <OpoMenus
                            firstName={props.firstName}
                            lastName={props.lastName}
                            username={props.username}
                            currentUrl={props.currentUrl}
                        />
                    );
                }
            } else {
                <CenterMenus
                    firstName={props.firstName}
                    lastName={props.lastName}
                    username={props.username}
                    currentUrl={props.currentUrl}
                    centerId={props.centerId}
                    centerAlias={props.centerAlias}
                    center={props.center}
                    centerList={centerList}
                    notifications={props.notifications}
                    group={props.group}
                    organ={organ}
                    organType={organType}
                    onShowNotifications={props.onShowNotifications}
                />
            }

        case isCenterUser:
            return (
                <CenterMenus
                    firstName={props.firstName}
                    lastName={props.lastName}
                    username={props.username}
                    currentUrl={props.currentUrl}
                    centerId={props.centerId}
                    centerAlias={props.centerAlias}
                    center={props.center}
                    centerList={centerList}
                    notifications={props.notifications}
                    group={props.group}
                    organ={organ}
                    organType={organType}
                    onShowNotifications={props.onShowNotifications}
                />
            );

        case isLogisticsPhlebotUser:
        case isLogisticsProviderUser:
            return (
                <LogisticsProviderMenus
                    firstName={props.firstName}
                    lastName={props.lastName}
                    username={props.username}
                    currentUrl={props.currentUrl}
                    courierName={props.courierName}
                />
            );

        case isMicrositeCoach:
            return (
                <MicrositeCoachMenus
                    firstName={props.firstName}
                    lastName={props.lastName}
                    username={props.username}
                    currentUrl={props.currentUrl}
                />
            );

        case isNkdoUser:
            return (
                <NkdoMenus
                    history={props.history}
                    location={props.location}
                    match={props.match}
                    firstName={props.firstName}
                    lastName={props.lastName}
                    username={props.username}
                    currentUrl={props.currentUrl}
                    group={props.group}
                    roles={props.roles}
                />
            );

        case isNkrLabUser:
            return (
                <MicrositeCoachMenus
                    firstName={props.firstName}
                    lastName={props.lastName}
                    username={props.username}
                    currentUrl={props.currentUrl}
                />
            );

        case isOpoUser:
            return (
                <OpoMenus
                    firstName={props.firstName}
                    lastName={props.lastName}
                    username={props.username}
                    currentUrl={props.currentUrl}
                />
            )

        case isLoginRequired == false:
            return (
                <OpsMenus
                    firstName={props.firstName}
                    lastName={props.lastName}
                    currentUrl={props.currentUrl}
                    pathname={props.location.pathname}
                />
            );
    }

    return null;
}
